(() => {
  if (window.ScrptdWishlist) return;

  const STORAGE_KEY = 'scrptd:wishlist:v1';
  const root = document.querySelector('[data-scrptd-wishlist-root]');
  if (!root) return;

  const enabled = root.dataset.enabled === 'true';
  const dialog = root.querySelector('[data-scrptd-wishlist-dialog]');
  const shareDialog = root.querySelector('[data-scrptd-wishlist-share-dialog]');
  const shareOpenButton = root.querySelector('[data-scrptd-wishlist-share-open]');
  const shareLinkInput = root.querySelector('[data-scrptd-wishlist-share-link]');
  const shareStatusNode = root.querySelector('[data-scrptd-wishlist-share-status]');
  const itemsNode = root.querySelector('[data-scrptd-wishlist-items]');
  const emptyNode = root.querySelector('[data-scrptd-wishlist-empty]');
  const statusNode = root.querySelector('[data-scrptd-wishlist-status]');
  const addAllButton = root.querySelector('[data-scrptd-wishlist-add-all]');
  const triggerTemplate = root.querySelector('[data-scrptd-wishlist-trigger-template]');
  const productButton = root.querySelector('[data-scrptd-product-wishlist]');
  const productDataNode = root.querySelector('[data-scrptd-wishlist-product-json]');
  const copyNode = root.querySelector('[data-scrptd-wishlist-copy]');
  const rootPath = () => window.Shopify?.routes?.root || '/';
  let items = readItems();
  let productData = parseJSON(productDataNode?.textContent, null);
  const copy = parseJSON(copyNode?.textContent, {});

  function parseJSON(value, fallback) {
    try { return JSON.parse(value || ''); } catch (_) { return fallback; }
  }

  function readItems() {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value.filter((item) => item?.handle && item?.variantId) : [];
    } catch (_) {
      return [];
    }
  }

  function saveItems() {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, 60))); } catch (_) {}
    updateUI();
    document.dispatchEvent(new CustomEvent('scrptd:wishlist-change', { detail: { items: items.slice() } }));
  }

  function encodeSharePayload() {
    const payload = items.slice(0, 60).map((item) => [String(item.handle), Number(item.variantId)]);
    try {
      return btoa(JSON.stringify(payload)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
    } catch (_) {
      return '';
    }
  }

  function decodeSharePayload(value) {
    try {
      const base64 = String(value || '').replace(/-/g, '+').replace(/_/g, '/');
      const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
      const payload = JSON.parse(atob(padded));
      if (!Array.isArray(payload)) return [];
      return payload.slice(0, 60).filter((entry) => Array.isArray(entry) && /^[a-z0-9][a-z0-9-]*$/i.test(String(entry[0] || '')) && Number(entry[1]));
    } catch (_) {
      return [];
    }
  }

  function shareUrl() {
    const url = new URL(rootPath(), window.location.origin);
    const payload = encodeSharePayload();
    if (payload) url.searchParams.set('scrptd_wishlist', payload);
    return url.toString();
  }

  function updateShareLinks() {
    const url = shareUrl();
    const text = copy.shareText || 'Meine SCRPTD Wishlist';
    if (shareLinkInput) shareLinkInput.value = url;
    const targets = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
      x: `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
      whatsapp: `https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`,
      telegram: `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
      pinterest: `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}&description=${encodeURIComponent(text)}`,
      email: `mailto:?subject=${encodeURIComponent(text)}&body=${encodeURIComponent(`${text}\n\n${url}`)}`
    };
    root.querySelectorAll('[data-scrptd-share-network]').forEach((link) => {
      link.href = targets[link.dataset.scrptdShareNetwork] || url;
    });
  }

  async function shareWithInstalledApps() {
    const url = shareUrl();
    const text = copy.shareText || 'Meine SCRPTD Wishlist';
    if (navigator.share) {
      try {
        await navigator.share({ title: text, text, url });
        return;
      } catch (error) {
        if (error?.name === 'AbortError') return;
      }
    }
    await copyShareLink();
  }

  async function importSharedWishlist() {
    const payload = decodeSharePayload(new URL(window.location.href).searchParams.get('scrptd_wishlist'));
    if (!payload.length) return;
    const imported = await Promise.all(payload.map(async ([handle, variantId]) => {
      try {
        const response = await fetch(`${rootPath()}products/${encodeURIComponent(handle)}.js`, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) return null;
        const normalized = normalizedExternalProduct(await response.json());
        if (!normalized) return null;
        const variant = normalized.variants.find((entry) => String(entry.id) === String(variantId) && entry.available)
          || normalized.variants.find((entry) => entry.available);
        if (!variant) return null;
        return {
          productId: normalized.id,
          handle: normalized.handle,
          title: normalized.title,
          url: normalized.url,
          image: variant.image || normalized.image,
          variantId: Number(variant.id),
          variantTitle: variant.title,
          sizeIndex: productSizeIndex(normalized),
          price: variant.price,
          optionNames: normalized.optionNames,
          variants: normalized.variants
        };
      } catch (_) {
        return null;
      }
    }));
    const valid = imported.filter(Boolean);
    if (!valid.length) return;
    const importedHandles = new Set(valid.map((item) => item.handle));
    items = valid.concat(items.filter((item) => !importedHandles.has(item.handle))).slice(0, 60);
    saveItems();
  }

  function normalize(value) {
    return String(value || '').trim().toLowerCase().normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss');
  }

  function productSizeIndex(data) {
    const names = Array.isArray(data?.optionNames) ? data.optionNames : [];
    const explicit = names.findIndex((name) => {
      const value = normalize(name);
      return value.includes('size') || value.includes('grosse') || value.includes('groesse');
    });
    if (explicit >= 0) return explicit;
    const known = new Set(['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl']);
    return names.findIndex((_, index) => (data.variants || []).some((variant) => known.has(normalize(variant.options?.[index]))));
  }

  function selectedVariant(data = productData) {
    if (!data) return null;
    const input = document.querySelector('.product-content-box form[action*="/cart/add"] input[name="id"], form.scrptd-product-form input[name="id"]');
    const selected = (data.variants || []).find((variant) => String(variant.id) === String(input?.value));
    return selected || (data.variants || []).find((variant) => variant.available) || data.variants?.[0] || null;
  }

  function variantLabel(item, variant) {
    const index = Number.isInteger(item.sizeIndex) ? item.sizeIndex : -1;
    if (index >= 0 && variant?.options?.[index]) return variant.options[index];
    return variant?.title && variant.title !== 'Default Title' ? variant.title : 'ONE SIZE';
  }

  function itemFromProduct() {
    const variant = selectedVariant();
    if (!productData || !variant) return null;
    return {
      productId: productData.id,
      handle: productData.handle,
      title: productData.title,
      url: productData.url,
      image: variant.image || productData.image,
      variantId: Number(variant.id),
      variantTitle: variant.title,
      sizeIndex: productSizeIndex(productData),
      price: variant.price,
      optionNames: productData.optionNames || [],
      variants: productData.variants || []
    };
  }

  function imageSource(value) {
    if (!value) return '';
    if (typeof value === 'string') return value;
    return value.src || value.url || '';
  }

  function formattedPrice(value) {
    if (typeof value === 'string' && /[^\d.,]/.test(value)) return value;
    const cents = Number(value);
    if (!Number.isFinite(cents)) return String(value || '');
    if (typeof window.Shopify?.formatMoney === 'function') return window.Shopify.formatMoney(cents);
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'EUR'
      }).format(cents / 100);
    } catch (_) {
      return `${(cents / 100).toFixed(2)} EUR`;
    }
  }

  function normalizedExternalProduct(data) {
    if (!data?.handle || !Array.isArray(data.variants)) return null;
    const optionNames = (data.options || []).map((option) => typeof option === 'string' ? option : option?.name).filter(Boolean);
    const productImage = imageSource(data.featured_image) || imageSource(data.images?.[0]);
    const normalized = {
      id: data.id,
      handle: data.handle,
      title: data.title,
      url: data.url || `${rootPath()}products/${encodeURIComponent(data.handle)}`,
      image: productImage,
      optionNames,
      variants: []
    };
    normalized.variants = data.variants.map((variant) => ({
      id: Number(variant.id),
      title: variant.title,
      available: Boolean(variant.available),
      price: formattedPrice(variant.price),
      options: variant.options || [variant.option1, variant.option2, variant.option3].filter((value) => value != null),
      image: imageSource(variant.featured_image) || productImage
    }));
    return normalized;
  }

  function addExternalProduct(data, variantId) {
    const normalized = normalizedExternalProduct(data);
    if (!normalized) return false;
    const variant = normalized.variants.find((entry) => String(entry.id) === String(variantId) && entry.available)
      || normalized.variants.find((entry) => entry.available);
    if (!variant) return false;
    const item = {
      productId: normalized.id,
      handle: normalized.handle,
      title: normalized.title,
      url: normalized.url,
      image: variant.image || normalized.image,
      variantId: Number(variant.id),
      variantTitle: variant.title,
      sizeIndex: productSizeIndex(normalized),
      price: variant.price,
      optionNames: normalized.optionNames,
      variants: normalized.variants
    };
    items = items.filter((stored) => stored.handle !== item.handle);
    items.unshift(item);
    saveItems();
    return true;
  }

  function removeExternalProduct(handle) {
    const next = items.filter((item) => item.handle !== handle);
    if (next.length === items.length) return false;
    items = next;
    saveItems();
    return true;
  }

  function hasProduct(handle) {
    return items.some((item) => item.handle === handle);
  }

  function injectHeaderTriggers(scope = document) {
    if (!enabled || !triggerTemplate) return;
    scope.querySelectorAll('[data-scrptd-wishlist-slot]').forEach((slot) => {
      if (slot.querySelector('[data-scrptd-wishlist-open]')) return;
      slot.append(triggerTemplate.content.cloneNode(true));
    });
    scope.querySelectorAll('[data-scrptd-header-actions]').forEach((actions) => {
      if (actions.querySelector('[data-scrptd-wishlist-open]')) return;
      const slot = document.createElement('span');
      slot.dataset.scrptdWishlistSlot = '';
      slot.className = 'scrptd-wishlist-slot';
      const cart = actions.querySelector('a[href*="/cart"]');
      if (cart) actions.insertBefore(slot, cart);
      else actions.append(slot);
      slot.append(triggerTemplate.content.cloneNode(true));
    });
  }

  function placeProductControls() {
    const row = document.querySelector('[data-scrptd-product-rating]');
    const title = document.querySelector('.product-content-box .product-title');
    const imageBox = document.querySelector('.product-box > .product-image-box');
    let targetRow = row;

    if (!targetRow && productButton && title) {
      targetRow = document.createElement('div');
      targetRow.className = 'scrptd-product-rating-row scrptd-product-rating-row--wishlist-only';
      targetRow.dataset.scrptdProductRating = '';
      title.after(targetRow);
    }

    if (targetRow && productButton && !targetRow.contains(productButton)) {
      productButton.hidden = false;
      targetRow.append(productButton);
    }

    if (!targetRow) return;
    if (window.matchMedia('(max-width: 805px)').matches && imageBox) {
      if (imageBox.nextElementSibling !== targetRow) imageBox.after(targetRow);
    } else if (title && title.nextElementSibling !== targetRow) {
      title.after(targetRow);
    }
  }

  function moveInventoryNote(scope = document) {
    const submit = scope.querySelector?.('[data-scrptd-product-submit]') || document.querySelector('[data-scrptd-product-submit]');
    const content = document.querySelector('.product-content-box');
    if (!submit || !content) return;

    const candidates = Array.from(content.querySelectorAll('p, small, span, div, [class*="inventory"], [class*="stock"]'));
    const match = candidates.find((node) => {
      if (node.classList.contains('scrptd-inventory-note')) return false;
      if (node.closest('[data-scrptd-stock-timer], [data-scrptd-product-sizes]')) return false;
      const text = String(node.textContent || '').replace(/\s+/g, ' ').trim();
      return text.length <= 90 && /nur noch\s+\d+\s+(?:verf(?:ü|ue)gbar|auf lager)/i.test(text);
    });
    if (!match) return;

    let note = match;
    while (note.parentElement && note.parentElement !== content && note.parentElement.children.length === 1) {
      const parentText = String(note.parentElement.textContent || '').replace(/\s+/g, ' ').trim();
      if (parentText !== String(note.textContent || '').replace(/\s+/g, ' ').trim()) break;
      if (note.parentElement.matches('form, .add-to-cart, .add-to-cart-section')) break;
      note = note.parentElement;
    }
    note.classList.add('scrptd-inventory-note');
    submit.insertAdjacentElement('afterend', note);
  }

  function updateHeaderCounts() {
    document.querySelectorAll('[data-scrptd-wishlist-count]').forEach((node) => {
      node.textContent = String(items.length);
      node.hidden = items.length === 0;
    });
  }

  function updateProductButton() {
    if (!productButton || !productData) return;
    const active = items.some((item) => item.handle === productData.handle);
    productButton.classList.toggle('is-active', active);
    productButton.setAttribute('aria-pressed', String(active));
    productButton.setAttribute('aria-label', active ? (copy.productRemoveLabel || 'Aus Wishlist entfernen') : (copy.productAddLabel || 'Zur Wishlist hinzufügen'));
  }

  function renderItems() {
    if (!itemsNode || !emptyNode || !addAllButton) return;
    itemsNode.replaceChildren();
    emptyNode.hidden = items.length > 0;
    addAllButton.disabled = items.length === 0;
    if (shareOpenButton) shareOpenButton.disabled = items.length === 0;

    items.forEach((item) => {
      const row = document.createElement('article');
      row.className = 'scrptd-wishlist-item';
      row.dataset.handle = item.handle;

      const image = document.createElement('img');
      image.className = 'scrptd-wishlist-item__image';
      image.src = item.image || '';
      image.alt = item.title || '';
      image.loading = 'lazy';

      const content = document.createElement('div');
      content.className = 'scrptd-wishlist-item__content';
      const title = document.createElement('a');
      title.className = 'scrptd-wishlist-item__title';
      title.href = item.url || `${rootPath()}products/${encodeURIComponent(item.handle)}`;
      title.textContent = item.title;
      const price = document.createElement('p');
      price.className = 'scrptd-wishlist-item__price';
      price.textContent = item.price || '';
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'scrptd-wishlist-item__remove';
      remove.dataset.wishlistRemove = item.handle;
      remove.textContent = copy.removeLabel || 'ENTFERNEN';

      const controls = document.createElement('div');
      controls.className = 'scrptd-wishlist-item__controls';
      const select = document.createElement('select');
      select.className = 'scrptd-wishlist-item__select';
      select.dataset.wishlistVariant = item.handle;
      select.setAttribute('aria-label', `${copy.sizeLabel || 'GRÖSSE'}: ${item.title}`);
      (item.variants || []).filter((variant) => variant.available).forEach((variant) => {
        const option = document.createElement('option');
        option.value = String(variant.id);
        option.textContent = `${copy.sizeLabel || 'GRÖSSE'}: ${variantLabel(item, variant)}`;
        option.selected = String(variant.id) === String(item.variantId);
        select.append(option);
      });
      const add = document.createElement('button');
      add.type = 'button';
      add.className = 'scrptd-wishlist-item__add';
      add.dataset.wishlistAdd = item.handle;
      add.textContent = copy.addLabel || 'IN DEN WARENKORB';
      add.disabled = !select.options.length;
      controls.append(select, add);
      content.append(title, price, remove, controls);
      row.append(image, content);
      itemsNode.append(row);
    });
  }

  function updateUI() {
    updateHeaderCounts();
    updateProductButton();
    renderItems();
  }

  function toggleCurrentProduct() {
    const item = itemFromProduct();
    if (!item) return;
    const index = items.findIndex((stored) => stored.handle === item.handle);
    if (index >= 0) items.splice(index, 1);
    else items.unshift(item);
    saveItems();
  }

  function openDialog(opener) {
    if (!dialog) return;
    dialog.dataset.opener = opener?.id || '';
    renderItems();
    document.body.classList.add('scrptd-wishlist-open');
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    dialog.querySelector('[data-scrptd-wishlist-close]')?.focus({ preventScroll: true });
  }

  function closeDialog() {
    if (!dialog) return;
    if (shareDialog?.open) closeShareDialog();
    document.body.classList.remove('scrptd-wishlist-open');
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  function openShareDialog() {
    if (!shareDialog || !items.length) return;
    updateShareLinks();
    if (shareStatusNode) shareStatusNode.textContent = '';
    if (typeof shareDialog.showModal === 'function') shareDialog.showModal();
    else shareDialog.setAttribute('open', '');
    shareDialog.querySelector('[data-scrptd-wishlist-share-close]')?.focus({ preventScroll: true });
  }

  function closeShareDialog() {
    if (!shareDialog) return;
    if (typeof shareDialog.close === 'function' && shareDialog.open) shareDialog.close();
    else shareDialog.removeAttribute('open');
    shareOpenButton?.focus({ preventScroll: true });
  }

  async function copyShareLink() {
    const value = shareLinkInput?.value || shareUrl();
    try {
      if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(value);
      else {
        shareLinkInput?.select();
        if (!document.execCommand('copy')) throw new Error('copy failed');
      }
      if (shareStatusNode) shareStatusNode.textContent = copy.copiedMessage || 'LINK KOPIERT.';
    } catch (_) {
      shareLinkInput?.focus();
      shareLinkInput?.select();
      if (shareStatusNode) shareStatusNode.textContent = copy.copyErrorMessage || 'LINK BITTE MANUELL KOPIEREN.';
    }
  }

  async function liveVariant(item) {
    try {
      const response = await fetch(`${rootPath()}products/${encodeURIComponent(item.handle)}.js`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) return null;
      const product = await response.json();
      return product.variants?.find((variant) => String(variant.id) === String(item.variantId) && variant.available) || null;
    } catch (_) {
      return null;
    }
  }

  async function addToCart(requestedItems, removeHandles) {
    const confirmed = [];
    for (const item of requestedItems) {
      const variant = await liveVariant(item);
      if (variant) confirmed.push({ id: Number(variant.id), quantity: 1 });
    }
    if (!confirmed.length) throw new Error(copy.errorMessage || 'Nicht verfügbar');

    const response = await fetch(`${rootPath()}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: confirmed })
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || copy.errorMessage || 'Fehler');

    items = items.filter((item) => !removeHandles.includes(item.handle));
    saveItems();
    if (statusNode) statusNode.textContent = copy.addedMessage || 'ZUM WARENKORB HINZUGEFÜGT.';

    const cart = typeof window.ScrptdFetchConfirmedCart === 'function'
      ? await window.ScrptdFetchConfirmedCart(confirmed)
      : await fetch(`${rootPath()}cart.js?_=${Date.now()}`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }).then((cartResponse) => cartResponse.json());
    closeDialog();
    if (typeof window.openCartDrawerWithCart === 'function') window.openCartDrawerWithCart(cart);
    else if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
    else document.dispatchEvent(new CustomEvent('scrptd:cart-change', { detail: cart }));
  }

  document.addEventListener('click', (event) => {
    const shareTarget = event.target.closest('[data-scrptd-share-network]');
    if (shareTarget && ['tiktok', 'snapchat', 'instagram', 'airdrop'].includes(shareTarget.dataset.scrptdShareNetwork)) {
      event.preventDefault();
      shareWithInstalledApps();
      return;
    }
    const open = event.target.closest('[data-scrptd-wishlist-open]');
    if (open) { event.preventDefault(); openDialog(open); return; }
    if (event.target.closest('[data-scrptd-wishlist-share-open]')) { openShareDialog(); return; }
    if (event.target.closest('[data-scrptd-wishlist-share-close]')) { closeShareDialog(); return; }
    if (event.target.closest('[data-scrptd-wishlist-copy-link]')) { copyShareLink(); return; }
    if (event.target.closest('[data-scrptd-wishlist-close]')) { closeDialog(); return; }
    if (event.target.closest('[data-scrptd-product-wishlist]')) { toggleCurrentProduct(); return; }

    const remove = event.target.closest('[data-wishlist-remove]');
    if (remove) {
      items = items.filter((item) => item.handle !== remove.dataset.wishlistRemove);
      saveItems();
      return;
    }
    const add = event.target.closest('[data-wishlist-add]');
    if (add) {
      const item = items.find((entry) => entry.handle === add.dataset.wishlistAdd);
      if (!item) return;
      add.disabled = true;
      addToCart([item], [item.handle]).catch(() => {
        if (statusNode) statusNode.textContent = copy.errorMessage || 'DER ARTIKEL KONNTE NICHT HINZUGEFÜGT WERDEN.';
        add.disabled = false;
      });
    }
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-wishlist-variant]');
    if (select) {
      const item = items.find((entry) => entry.handle === select.dataset.wishlistVariant);
      const variant = item?.variants?.find((entry) => String(entry.id) === String(select.value));
      if (item && variant) {
        item.variantId = Number(variant.id);
        item.variantTitle = variant.title;
        item.price = variant.price;
        item.image = variant.image || item.image;
        saveItems();
      }
    }
  });

  addAllButton?.addEventListener('click', () => {
    addAllButton.disabled = true;
    const requested = items.slice();
    addToCart(requested, requested.map((item) => item.handle)).catch(() => {
      if (statusNode) statusNode.textContent = copy.errorMessage || 'DIE ARTIKEL KONNTEN NICHT HINZUGEFÜGT WERDEN.';
      addAllButton.disabled = false;
    });
  });

  dialog?.addEventListener('click', (event) => {
    if (event.target === dialog) closeDialog();
  });
  dialog?.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeDialog();
  });
  shareDialog?.addEventListener('click', (event) => {
    if (event.target === shareDialog) closeShareDialog();
  });
  shareDialog?.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeShareDialog();
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-node-type="add-to-cart-option-pill"]')) {
      window.setTimeout(updateProductButton, 20);
    }
  }, true);

  let resizeFrame = 0;
  window.addEventListener('resize', () => {
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(placeProductControls);
  }, { passive: true });

  const initialize = (scope = document) => {
    injectHeaderTriggers(scope);
    placeProductControls();
    moveInventoryNote(scope);
    updateUI();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => {
    initialize();
    importSharedWishlist();
  }, { once: true });
  else {
    initialize();
    importSharedWishlist();
  }

  const productContent = document.querySelector('.product-content-box');
  if (productContent) {
    let mutationFrame = 0;
    new MutationObserver(() => {
      cancelAnimationFrame(mutationFrame);
      mutationFrame = requestAnimationFrame(() => moveInventoryNote());
    }).observe(productContent, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  window.addEventListener('storage', (event) => {
    if (event.key !== STORAGE_KEY) return;
    items = readItems();
    updateUI();
  });

  window.ScrptdWishlist = {
    enabled,
    open: openDialog,
    items: () => items.slice(),
    has: hasProduct,
    addProduct: addExternalProduct,
    removeProduct: removeExternalProduct
  };
})();
